/*
 *
 *  * Copyright (c) Funtip GbR 2018.
 *  * Simon Oldeboershuis, Perry Prust
 *
 */

import { AnyAction, isType } from 'typescript-fsa';
import { Job } from '../../services/playlist';
import {
    setAvailableJobs,
    setJobSchedulerState,
    setScheduledJobs,
    setShowCreateJobFormAction,
    jobManagementSetServerAvailable
} from './actions';

export interface JobServerState {
    jobs: Job[];
    availableJobNames: string[];
    enabled: boolean;
    showCreateJobForm: boolean;
    serverAvailable: boolean;
}

export interface JobManagementState {
    [serverName: string]: JobServerState;
}

export const initialJobManagementState: JobManagementState = {};

export function jobManagementReducer(state: JobManagementState = initialJobManagementState, action: AnyAction) {
    if (isType(action, setScheduledJobs)) {
        let serverState: JobServerState = Object.assign({}, state[action.payload.serverName], {
            jobs: action.payload.jobs
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
    } else if (isType(action, setAvailableJobs)) {
        let serverState: JobServerState = Object.assign({}, state[action.payload.serverName], {
            availableJobNames: action.payload.jobNames
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
    } else if (isType(action, setJobSchedulerState)) {
        let serverState: JobServerState = Object.assign({}, state[action.payload.serverName], {
            enabled: action.payload.enabled
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
    } else if (isType(action, setShowCreateJobFormAction)) {
        let serverState: JobServerState = Object.assign({}, state[action.payload.serverName], {
            showCreateJobForm: action.payload.show
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
    } else if (isType(action, jobManagementSetServerAvailable)) {
        let serverState: JobServerState = Object.assign({}, state[action.payload.serverName], {
            serverAvailable: action.payload.available
        });
        return Object.assign({}, state, { [action.payload.serverName]: serverState });
    } else {
        return state;
    }
}
